import { BffServiceConfig } from '../models/config';
import axios from 'axios';

export class UnsubscribeSource {
  private readonly bffConfig: BffServiceConfig;

  constructor(bffConfig: BffServiceConfig) {
    this.bffConfig = bffConfig;
  }

  public async setUnsubscribe(email: string) {
    try {
      const { protocol, hostname } = this.bffConfig;
      const bffService = `${protocol}//${hostname}/api/v1`;
      const response = await axios.put(`${bffService}/unsubscribe/${email}`, {});

      return {}; //response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
